import { createContext, useCallback, useContext, useMemo, useState } from 'react';

// Shares which homepage sections actually have content, so the hero's quick
// access links only point at sections that are on the page, and lets those
// links open a specific tab of the product showcase.
const HomeSectionsContext = createContext({
  available: {},
  setAvailability: () => {},
  tabRequest: null,
  requestTab: () => {},
});

export function HomeSectionsProvider({ children }) {
  const [available, setAvailable] = useState({});
  const [tabRequest, setTabRequest] = useState(null);

  const setAvailability = useCallback((key, value) => {
    setAvailable((previous) => (previous[key] === value ? previous : { ...previous, [key]: value }));
  }, []);

  // The nonce lets the same tab be requested twice in a row (e.g. after the
  // user scrolled away) and still trigger the scroll.
  const requestTab = useCallback((tab) => setTabRequest({ tab, nonce: Date.now() }), []);

  const value = useMemo(
    () => ({ available, setAvailability, tabRequest, requestTab }),
    [available, setAvailability, tabRequest, requestTab]
  );

  return <HomeSectionsContext.Provider value={value}>{children}</HomeSectionsContext.Provider>;
}

export const useHomeSections = () => useContext(HomeSectionsContext);
